import { useNavigate } from 'react-router-dom';
import {
  SUPPORT_PHONE_DISPLAY,
  SUPPORT_PHONE_TEL,
  LEGAL_OPERATOR_NAME,
  LEGAL_ADDRESS_STREET,
  LEGAL_ADDRESS_CITY,
  LEGAL_ADDRESS_COUNTRY,
} from '../constants/contact';

export default function Impressum() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="bg-white border-b border-gray-200 sticky top-0 z-10">
        <div className="max-w-3xl mx-auto px-6 py-4 flex items-center gap-4">
          <button
            onClick={() => navigate('/')}
            className="flex items-center gap-2 text-sm text-gray-500 hover:text-gray-800 transition-colors"
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M19 12H5M12 5l-7 7 7 7" />
            </svg>
            Zurück
          </button>
          <span className="text-gray-300">|</span>
          <span className="text-sm font-semibold text-gray-700" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
            Candlear Booking
          </span>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-3xl mx-auto px-6 py-12">
        <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-8 md:p-12">

          <h1 className="text-3xl font-bold text-gray-900 mb-2" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
            Impressum
          </h1>
          <p className="text-sm text-gray-400 mb-1">Angaben gemäß § 5 DDG</p>
          <p className="text-sm text-gray-400 mb-8">Stand: August 2026</p>

          {/* Anbieter */}
          <section className="mb-8">
            <h2 className="text-base font-bold text-gray-900 mb-3 pb-2 border-b border-gray-200" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
              Anbieter
            </h2>
            <div className="text-sm text-gray-800 leading-loose">
              <p className="font-semibold">{LEGAL_OPERATOR_NAME}</p>
              <p>{LEGAL_ADDRESS_STREET}</p>
              <p>{LEGAL_ADDRESS_CITY}</p>
              <p>{LEGAL_ADDRESS_COUNTRY}</p>
            </div>
          </section>

          {/* Kontakt */}
          <section className="mb-8">
            <h2 className="text-base font-bold text-gray-900 mb-3 pb-2 border-b border-gray-200" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
              Kontakt
            </h2>
            <div className="text-sm text-gray-800 leading-loose">
              <p>
                E-Mail:{' '}
                <a href="mailto:support@candlear.de" className="text-[#FF6D00] hover:underline">
                  support@candlear.de
                </a>
              </p>
              <p>
                Telefon:{' '}
                <a href={`tel:${SUPPORT_PHONE_TEL}`} className="text-[#FF6D00] hover:underline">
                  {SUPPORT_PHONE_DISPLAY}
                </a>
              </p>
              <p>
                Website:{' '}
                <a href="https://candlear.de" className="text-[#FF6D00] hover:underline">
                  https://candlear.de
                </a>
              </p>
            </div>
          </section>

          {/* Umsatzsteuer */}
          <section className="mb-8">
            <h2 className="text-base font-bold text-gray-900 mb-3 pb-2 border-b border-gray-200" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
              Umsatzsteuer
            </h2>
            <p className="text-sm text-gray-700 leading-relaxed">
              Gemäß § 19 UStG (Kleinunternehmerregelung) wird keine Umsatzsteuer erhoben und ausgewiesen.
            </p>
          </section>

          {/* Verantwortlich für den Inhalt */}
          <section className="mb-8">
            <h2 className="text-base font-bold text-gray-900 mb-3 pb-2 border-b border-gray-200" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
              Verantwortlich für den Inhalt (§ 18 Abs. 2 MStV)
            </h2>
            <div className="text-sm text-gray-800 leading-loose">
              <p className="font-semibold">Jannick Müller</p>
              <p>{LEGAL_ADDRESS_STREET}</p>
              <p>{LEGAL_ADDRESS_CITY}</p>
            </div>
          </section>

          {/* Verbraucherstreitbeilegung */}
          <section className="mb-8">
            <h2 className="text-base font-bold text-gray-900 mb-3 pb-2 border-b border-gray-200" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
              Verbraucherstreitbeilegung (§ 36 VSBG)
            </h2>
            <p className="text-sm text-gray-700 leading-relaxed">
              Unser Angebot richtet sich ausschließlich an Unternehmer (§ 14 BGB). Wir sind daher nicht bereit und
              nicht verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen
              (kein Verbrauchergeschäft im Sinne des § 13 BGB).
            </p>
          </section>

          {/* Haftungshinweis */}
          <section className="mb-8">
            <h2 className="text-base font-bold text-gray-900 mb-3 pb-2 border-b border-gray-200" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
              Haftung für Inhalte
            </h2>
            <p className="text-sm text-gray-700 leading-relaxed">
              Als Diensteanbieter sind wir gemäß § 7 Abs. 1 DDG für eigene Inhalte auf diesen Seiten nach den
              allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 DDG sind wir als Diensteanbieter jedoch nicht
              verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu
              forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
            </p>
            <p className="text-sm text-gray-700 leading-relaxed mt-3">
              Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen
              bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer
              konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese
              Inhalte umgehend entfernen.
            </p>
          </section>

          <section>
            <h2 className="text-base font-bold text-gray-900 mb-3 pb-2 border-b border-gray-200" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
              Haftung für Links
            </h2>
            <p className="text-sm text-gray-700 leading-relaxed">
              Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben.
              Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten
              Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten
              wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren
              zum Zeitpunkt der Verlinkung nicht erkennbar. Bei Bekanntwerden von Rechtsverletzungen werden wir
              derartige Links umgehend entfernen.
            </p>
          </section>

        </div>
      </div>
    </div>
  );
}
